export default "//yastatic.net/s3/distribution/pythia/frontend/_/c422e7f654785fc6f6f8e09ff458f512.png";